import React from 'react'
import ayur from '../Images/Ayurveda.jpg'
import ayur2 from '../Images/ayurveda1.jpg'
import '../Cardpage.css'

function Ayurvedic() {
  return (
<>
    <div className='cardpagediv'>
      <h3 className='cardpagehead'>Ayurvedic Products</h3>
      <img src={ayur2} className='w-100 imgbanner' alt="" />
    </div>
    <p className='cardpagepara1 ms-2 me-2'>
      We have a wide verieties of Ayurvedic products in our store.
    </p>
    <h5 className='cardpagehead5 ms-2 mb-4'>
      List of major Ayurvedic products:
    </h5>

    <div>
    <ul>
      <li>Himalaya</li>
      <li>Leaf n Leaf</li>
      <li>Kandamkulathy</li>
      <li>Pankachakasturi</li>
      <li>Krisna Thulasi</li>
      <li>Ortho Herb</li>
    </ul>
    </div>
    <p className='ms-2 pagebott'>We provide best quality products to our customers.</p>
    </>
  )
}

export default Ayurvedic